export default __webpack_public_path__ + "static/media/members.f6bd191e.svg";